import React from "react";
import { Auth } from "aws-amplify";
import { Button } from "react-bootstrap";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";

import { yupResolver } from "@hookform/resolvers/yup";
import { verifyEmail } from "../Utility/Validations";
import { getTenantInfo, updateTenantFn } from "../Utility/ApiService";

// Cognito errors for an already-verified account (resendSignUp / confirmSignUp)
const ALREADY_VERIFIED_MSG = "Your email is already verified. Sign in with your email and password.";
const isAlreadyConfirmed = (error) => /already confirmed|current status is confirmed/i.test(error?.message || "");

const NonVerifyEmailModal = ({ setLoading, goToLogin }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
  } = useForm({
    resolver: yupResolver(verifyEmail),
    mode: "onChange",
  });
  const watchemail = watch("email");

  const onSubmit = async (data) => {
    try {
      setLoading(true);
      await Auth.confirmSignUp(data.email, data.code);
      const tenantInfo = await getTenantInfo(watchemail);
      await updateTenantFn({
        email: tenantInfo[0].email,
        id: tenantInfo[0].id,
        first_name: tenantInfo[0].first_name,
        last_name: tenantInfo[0].last_name,
      });
      setLoading(false);
      goToLogin();
    } catch (error) {
      setLoading(false);
      console.log("error confirming sign up", error);
      toast.error(isAlreadyConfirmed(error) ? ALREADY_VERIFIED_MSG : error.message || "Something went wrong please try again later");
    }
  };

  const reSendCode = async () => {
    try {
      setLoading(true);
      await Auth.resendSignUp(watchemail);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("error reSendCode", error);
      toast.error(isAlreadyConfirmed(error) ? ALREADY_VERIFIED_MSG : error.message);
    }
  };

  return (
    <div>
      <div className="d-flex justify-content-end">
        <i
          className="fa fa-home cursor-pointer "
          onClick={() => goToLogin()}
          style={{ fontSize: "25px", marginBottom: 20 }}
        />
      </div>
      <h2>Verify Email</h2>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="mb-3">
          <label className="form-label mb-2">What is the email address you used?</label>
          <input name="email" {...register("email")} type="email" className="form-control" placeholder="Email" />
          <p className="text-danger mt-2">{errors.email?.message}</p>
        </div>
        <div className="mb-3">
          <label className="form-label mb-2">Enter the code we've sent to your email</label>
          <input name="code" {...register("code")} type="text" className="form-control" placeholder="Code" />
        </div>
        <div className="text-end">
          <a
            style={{
              color: `${!watchemail || errors?.email?.message ? "#e1e1e1" : "#1a5e61"}`,
              pointerEvents: `${!watchemail || errors?.email?.message ? "none" : "initial"}`,
            }}
            onClick={(e) => {
              e.preventDefault();
              reSendCode();
            }}
            href="#"
          >
            Resend Code
          </a>
        </div>
        <div>
          <Button type="submit">Next</Button>
        </div>
      </form>
    </div>
  );
};

export default NonVerifyEmailModal;
